import { AUTOFILL_ANIMATION_NAME } from '../constants'

export function getInputType(props, state) {
  if (props.type !== 'password') return props.type

  return state.showPassword ? 'text' : 'password'
}

export function getAriaLabelledBy(props) {
  // If component doesn't have its own label then
  // it will have an external label with a ariaLabelledBy passed in
  return props.label ? 'label-' + props.id : props.ariaLabelledBy
}

export function isAutoFillEvent(event) {
  return event.animationName === AUTOFILL_ANIMATION_NAME
}

export const getIconColour = (focused, theme) =>
  focused ? theme.primaryColour : theme.grey350
